import { profileEntity } from "@/components/common/structured-data/profile-entity";
import { remediumOrganization } from "@/components/common/structured-data/organization-structured-data";
import { getFullImageUrl } from "@/service/image/image-uploaded";
import {
  contentDates,
  JsonLd,
  paywalledPart,
} from "@/components/common/structured-data/json-ld";

// Wspólny dla publikacji (NewsArticle) i vademecum (Article — wiedza stała, nie wiadomość).
export const ArticleStructuredData = ({
  article: { image, updatedAt, publishedAt, authors, seo },
  headline,
  url,
  isFree,
  type = "NewsArticle",
}: {
  article: ArticleVM;
  headline: string;
  url: string;
  isFree: boolean;
  type?: "NewsArticle" | "Article";
}) => {
  return (
    <JsonLd
      data={{
        "@type": type,
        mainEntityOfPage: {
          "@type": "WebPage",
          "@id": url,
        },
        headline,
        image: image ? getFullImageUrl(image) : undefined,
        ...contentDates(publishedAt, updatedAt),
        author: authors.map(profileEntity),
        publisher: remediumOrganization,
        description: seo.description || undefined,
        ...(isFree ? { isAccessibleForFree: true } : paywalledPart),
      }}
    />
  );
};
